import React from 'react';
import PropTypes from 'prop-types';
import { useTranslations } from '@lang';
import { CalendarIcon } from '@root/styles/icons';
import { Button } from '../Button';

export const CalendarButton = ({ onClick, textId = 'common.calendar.changeDateCTA' }) => {
  const { t } = useTranslations();
  return (
    <Button
      onClick={onClick}
      type="button"
      isSmall
      icon={<CalendarIcon width="14" height="14" className="journey-icon" />}
    >
      {t(textId)}
    </Button>
  );
};

CalendarButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
